export function roundToTwo(num) {
    return +(Math.round(num * 100) / 100);
}

export function formatCost(value) {
  if (value >= 1_000_000_000_000) {
    return (value / 1_000_000_000_000).toFixed(2) + " T";
  } else if (value >= 1_000_000_000) {
    return (value / 1_000_000_000).toFixed(2) + " B";
  } else if (value >= 1_000_000) {
    return (value / 1_000_000).toFixed(2) + " M";
  } else if (value >= 1_000) {
    return (value / 1_000).toFixed(2) + " K";
  } else {
    return value?.toFixed(2);
  }
}
